module.exports = __webpack_public_path__ + "img/LogoDashboard-12.5b0ec5d4.svg";